import { AppState } from '../store';

export const scannedCodeSelector = (state: AppState) =>
  state.barcodeScanner.scannedCode;
